import type { Order } from '../../type';

export const SESSION_STORAGE_KEYS = {
  CANCEL_REASON_STATE: 'cancel-reason-state',
  SUBSCRIPTION_GIFT_CONVERSION_FLAG: 'subscription-gift-conversion-flag',
  SUBSCRIPTION_GIFT_UUID: 'subscription-gift-uuid',
  MOCK_TIME_ENABLED: 'mock-time-enabled',
  MOCK_TIME_VALUE: 'mock-time-value',
  REFERRAL_INFO: 'referral-info',
  PREVIOUS_PATH: 'previous-path',
  USTORE_CHECKOUT_DELIVERY_FORM: 'ustore-checkout-delivery-form',
  ALREADY_REDIRECTED: 'already-redirected',
  USTORE_NUDGE_DRAWER: 'ustore-nudge-drawer',
  PRE_CUSTOMIZING_EXPECTED_PRICE_ORDER_ITEMS:
    'pre-customizing-expected-price-order-items',
  USTORE_ITEM_VIEW_EVENT: 'ustore-item-view-event',
  PAYMENT_CHANGE_SCROLL_POSITION: 'payment-change-scroll-position',
  AUTH_CERTIFICATION_REDIRECT_URI: 'auth-certification-redirect-uri',
  HOLIDAY_NOTICE_MODAL: ({
    id,
    deliveryDate,
  }: Partial<Pick<Order, 'id' | 'deliveryDate'>>) =>
    `holiday-notice-modal-${id}-${deliveryDate}`,
  RECENT_SUBSCRIPTION_ID: 'recent-subscription-id',
  BANNER_VIEW: (id: number) => `view_banner_${id}`,
  MARKET_CHECKOUT_ADDRESS_CONFIRM_BUBBLE_DISMISSED:
    'market-checkout-address-confirm-bubble-dismissed',
  LAST_PROCESSED_SUBSCRIPTION_IDEMPOTENCY_KEY:
    'last-processed-subscription-idempotency-key',
  /** 메인 팝업 '닫기'로 이번 세션에만 넘긴 배너 id 목록 */
  MAIN_POPUP_SESSION_SKIPPED_IDS: 'main-popup-session-skipped-ids',
  CHUNK_RELOAD_GUARD: 'chunk-reload-guard',
  /** 이미 구독 중이라는 안내에서 추가 신청을 골라 이번 세션에 넘겼는지 */
  BUYNOW_DUPLICATE_NOTICE_PASSED: 'buynow-duplicate-notice-passed',
  /** [QA] 다음 커마/재결제를 토스 테스트코드로 강제 실패시킬지 여부 (stage 전용) */
  QA_FORCE_PAYMENT_FAIL: 'qa-force-payment-fail',
  /** 커마 이번 주 Pick 추천 영역 끝 도달(view_recommendation_end) 세션당 1회 발화 가드 */
  CUSTOMIZING_RECOMMENDATION_END_VIEWED:
    'customizing-recommendation-end-viewed',
  /** 이유식박스를 이어갈지 묻는 안내에서 계속 받기를 눌렀는지 — 구독마다 따로 센다 */
  BABYFOOD_WEEK_BOUNDARY_NUDGE: (subscriptionId: number | undefined) =>
    `babyfood-week-boundary-nudge-${subscriptionId}`,
} as const;
